<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/controleFrota"> Marca Equipamento </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Controle Frota"
              v-model="descricao"
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A marca é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="controleFrota.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/controleFrota" color="error" class="mr-4" v-if="!readOnly">
            Cancelar
          </v-btn>
          <v-btn to="/controleFrota" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoControleFrota from "../../Tabs/TabControleFrota";
import { editarControleFrotaAsync } from "../../../services/controleFrotaService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarControleFrota",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("controleFrota", ["controleFrota"]),
    ...mapState("produto", ["produtos"]),
  },
  methods: {
    ...mapActions("produto", ["atualizarProdutos"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarControleFrotaAsync(
          this.controleFrota.id,
          this.descricao,
          this.controleFrota.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/controleFrota");
        }
      }
    },
    findProduto(controleFrotaId) {
      return this.produtos.filter((p) => {
        return p.idControleFrota == controleFrotaId && p.ativo === true;
      });
    },
    checkAssociacao: async function () {
      if (!this.controleFrota.ativo) {
        if (!this.produtos || this.produtos.length == 0) {
          this.overlay = true;
          await this.atualizarProdutos();
          this.overlay = false;
        }
        var produtos = this.findProduto(this.controleFrota.id);
        if (produtos != null && produtos.length > 0) {
          this.$alert(
            "O(s) produtos(s) '" +
              produtos.map((e) => e.descricao).join("', '") +
              "' estão ativos e associados a essa Família.",
            "Ação não permitida!",
            "error"
          );
          this.controleFrota.ativo = !this.controleFrota.ativo;
        }
      }
    }
  },
  created: function () {
    this.readOnly = !getUserPermission(8);
    this.descricao = this.controleFrota.descricao;
  },
  components: {
    TabNavegacaoControleFrota,
  },
};
</script>